module.exports = "<div class=\"container\">\r\n  <div class=\"page-header\">\r\n    <h1>Tervetuloa Metsävisan tehtävien ja tulosten hallintaan</h1>\r\n    <p class=\"lead\">Tehtävien ja Kilpailijoiden hallintaan pääsee ylävalikosta.</p>\r\n  </div>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/welcome/welcome.component.html
// module id = ./src/app/welcome/welcome.component.html
// module chunks = main